import React, { useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import Grid from "@mui/material/Grid";
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';

import { WEB_URL } from '../../api/URLs';
import useForm from '../../hooks/UseForm';
import { userActions } from '../../store/actions';
import { validateLogin } from '../../validations';
import { displayError } from '../../helpers';
import { PAGENAME_CONSTANTS } from '../../constants';
import Tracking from '../../services/tracking.service';
import { useNonInitialEffect } from '../../hooks/UseNonInitialEffect';
import { MixPanelTrackedLink, ShowSpinnerOrLabel, Textfield, PasswordInput } from '../../components';
import { useLocation, useNavigate } from 'react-router-dom';

export default function (props) {
    const location = useLocation();
    console.log(location)
    const history = useNavigate();
    const [state, setState] = useState({
        email: null,
        password: null
    });
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const loginResponse = useSelector(state => state.authentication.login_result);
    const errors = useSelector(state => state.validationErrors)

    const handleLogin = async () => {
        setLoading(true)
        const { email, password } = state;
        await dispatch(userActions.login(email, password))
        setLoading(false)
    }

    const handleStateChange = (e) => {
        const { name, value } = e.target;
        setState({
            ...state,
            [name]: value
        })
    }

    const trackAndSubmitOnEnter = e => {
        if (e.key == 'Enter') {
            Tracking.trackLink("Login", "button", "Tried to login by pressing 'Enter' key");
            handleSubmit();
        }
    }

    const { handleChange, handleSubmit } = useForm(handleLogin, validateLogin, handleStateChange, state);

    useEffect(() => {
        // Mixpanel Tracking Code Start
        Tracking.trackPage({ pageName: PAGENAME_CONSTANTS.LOGIN })
        // Mixpanel Tracking Code End
    }, [])

    useNonInitialEffect(() => {
        const redirectionUrl = location.state?.from || WEB_URL.PROFILE();
        if (loginResponse)
            history(redirectionUrl, { state: { ...location.state } })
    }, [loginResponse])

    return (
        <Box>
            <Typography gutterBottom align='center' component="h1" variant="h5" sx={formStyles.topHeading}>
                Login to your account
            </Typography>
            <Grid container spacing={3} sx={{ pt: '25px' }}>
                <Grid item xs={12}>
                    <Textfield
                        id="email"
                        name="email"
                        type="email"
                        label="Email address *"
                        value={state.email}
                        autoFocus
                        onChange={handleChange}
                        error={displayError(errors?.email)}
                        helperText={errors.email}
                        fullWidth />
                </Grid>
                <Grid item xs={12}
                    sx={{ textAlign: 'right' }}>
                    <PasswordInput
                        id="password"
                        name="password"
                        value={state.password}
                        label="Password *"
                        onChange={handleChange}
                        onKeyDown={trackAndSubmitOnEnter}
                        error={displayError(errors?.password)}
                        helperText={errors.password}
                        sx={{ mb: '10px' }}
                        fullWidth
                    />
                    <MixPanelTrackedLink
                        type="link"
                        label="Forgot Password"
                        context="Forgot Password"
                        underline="none"
                        href={WEB_URL.FORGOT_PASSWORD}
                    >
                        Forgot password?
                    </MixPanelTrackedLink>
                </Grid>
                <Grid item xs={12}>
                    <MixPanelTrackedLink
                        type="button"
                        label="login"
                        context="User Login"
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={loading}
                        fullWidth
                    >
                        <ShowSpinnerOrLabel label="Login" loading={loading} variant='white' />
                    </MixPanelTrackedLink>
                </Grid>
            </Grid>
        </Box>
    );
}

const formStyles = {
    topHeading: {
        width: '100%',
        paddingBottom: '10px',
        borderBottom: '1px solid #dee2e6',
    }
}
